export const LABEL_NEW_IMPORT = "New import";
export const LABEL_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON = "Update products that are not in any season";
export const LABEL_PRODUCTS_THAT_ARE_IN_SEASON = "Update products that are in season";
export const LABEL_UPDATE_PRODUCT_UNITS = "Update Units";
export const LABEL_SUPPLEMENTING_THE_MISSING_DATA = "Supplementing the missing data";
export const LABEL_OVERWRITING_DATA = "Overwriting data";
export const LABEL_ALL_SEASONS = "All seasons";
export const LABEL_SELECTED_SEASON = "Selected season";

export const LABEL_UPDATE_DYNAMIC_ATTRIBUTES = "Update dynamic product attributes";


export const OPERATION_NEW_IMPORT = "New import";
export const OPERATION_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON_OVERWRITING_DATA =
    "Update products that are not in any season - Overwriting data";
export const OPERATION_UPDATE_PRODUCTS_WITHOUT_SELECTED_SEASON_SUPPLEMENTING_DATA =
    "Update products that are not in any season - Supplementing the missing data";
export const OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_OVERWRITING_DATA_ALL_SEASONS =
    "Update products that are in season - Overwriting data - All seasons";
export const OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_OVERWRITING_DATA_SELECTED_SEASON =
    "Update products that are in season - Overwriting data - Selected season";
export const OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_SUPPLEMENTING_DATA_ALL_SEASONS =
    "Update products that are in season - Supplementing data - All seasons";
export const OPERATION_UPDATE_PRODUCTS_THAT_ARE_IN_SEASON_SUPPLEMENTING_DATA_SELECTED_SEASON =
    "Update products that are in season - Supplementing data - Selected season";